"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactPreferences = require("@trycourier/react-preferences");

var _useAtBottom = require("../../hooks/use-at-bottom");

var _Header = _interopRequireDefault(require("./Header"));

var _loading = _interopRequireDefault(require("./loading"));

var _Message = _interopRequireDefault(require("../Message"));

var _PaginationEnd = _interopRequireDefault(require("./PaginationEnd"));

var _TabList = _interopRequireDefault(require("../TabList"));

var _reactHooks = require("@trycourier/react-hooks");

var _styled = require("./styled");

var CourierLogo = function CourierLogo(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.4 4.539a.207.207 0 0 0 .031-.108A4.75 4.75 0 0 0 4.753.504 4.762 4.762 0 0 0 0 5.29C.021 7.854 2.178 10 4.732 10a4.744 4.744 0 0 0 4.581-3.434c.022-.064-.021-.139-.086-.171l-.193-.075a2.608 2.608 0 0 0-2.285.268c-.311.204-.537.365-.537.365a2.455 2.455 0 0 1-1.351.418c-1.342 0-2.275-1.094-2.425-2.425l-.108-.73a.626.626 0 0 0-.397-.493l-.268-.107c-.043-.022-.064-.075-.032-.118 1.148-1.535 2.554-1.202 2.554-1.202.246.022.46.118.633.236.246.172.44.419.558.698A2.8 2.8 0 0 0 7.94 4.914s1.094.043 1.46-.375zM16.77 6.524c0 1.93-1.47 3.38-3.39 3.38-1.92 0-3.38-1.438-3.38-3.38 0-1.964 1.46-3.412 3.38-3.412 1.931 0 3.39 1.459 3.39 3.412zm-4.678 0c0 .772.558 1.34 1.298 1.34.752 0 1.31-.568 1.31-1.34 0-.794-.558-1.374-1.31-1.374-.74 0-1.298.58-1.298 1.374zM23.766 6.738c0 1.856-1.298 3.165-3.122 3.165-1.835 0-3.155-1.309-3.155-3.165V3.24h2.114v3.498c0 .687.397 1.127 1.03 1.127.612 0 1.02-.44 1.02-1.127V3.24h2.102v3.498h.011zM28.991 3.187v1.931a3.832 3.832 0 0 0-.676-.075c-.89 0-1.598.461-1.598 1.706v3.015h-2.114V3.24h2.114v.687c.386-.515.944-.805 1.652-.805.193 0 .397.033.622.065zM32.124 1.255c0 .687-.568 1.266-1.255 1.266-.687 0-1.266-.579-1.266-1.266 0-.676.58-1.255 1.266-1.255.687 0 1.255.58 1.255 1.255zM31.91 3.24v6.524h-2.114V3.24h2.114zM39.227 7.05h-4.656c.16.675.719 1.094 1.438 1.094.633 0 .997-.269 1.083-.623h2.082c-.204 1.438-1.427 2.372-3.101 2.372-1.931 0-3.444-1.492-3.444-3.412 0-1.91 1.48-3.38 3.4-3.38 1.771 0 3.241 1.405 3.241 3.187.011.182-.021.525-.043.761zM37.06 5.718c-.054-.526-.558-.89-1.127-.89-.579 0-1.04.268-1.266.89h2.393zM44.388 3.187v1.931a3.83 3.83 0 0 0-.676-.075c-.89 0-1.599.461-1.599 1.706v3.015H40V3.24h2.114v.687c.386-.515.944-.805 1.652-.805.204 0 .408.033.622.065z",
    fill: "#B9C0CD"
  }));
};

CourierLogo.defaultProps = {
  width: "45",
  height: "10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var Messages = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _ref2, _labels$emptyState, _brand$inapp, _brand$inapp$emptySta, _brand$inapp2;

  var defaultIcon = _ref.defaultIcon,
      formatDate = _ref.formatDate,
      isMobile = _ref.isMobile,
      labels = _ref.labels,
      openLinksInNewTab = _ref.openLinksInNewTab,
      renderBlocks = _ref.renderBlocks,
      renderContainer = _ref.renderContainer,
      renderFooter = _ref.renderFooter,
      renderHeader = _ref.renderHeader,
      renderMessage = _ref.renderMessage,
      renderNoMessages = _ref.renderNoMessages,
      renderTabs = _ref.renderTabs,
      title = _ref.title;

  var _usePreferences = (0, _reactHooks.usePreferences)(),
      fetchRecipientPreferences = _usePreferences.fetchRecipientPreferences;

  var _useInbox = (0, _reactHooks.useInbox)(),
      brand = _useInbox.brand,
      currentTab = _useInbox.currentTab,
      fetchMessages = _useInbox.fetchMessages,
      isLoading = _useInbox.isLoading,
      markAllAsRead = _useInbox.markAllAsRead,
      _useInbox$messages = _useInbox.messages,
      messages = _useInbox$messages === void 0 ? [] : _useInbox$messages,
      setCurrentTab = _useInbox.setCurrentTab,
      startCursor = _useInbox.startCursor,
      tabs = _useInbox.tabs,
      toggleInbox = _useInbox.toggleInbox,
      unreadMessageCount = _useInbox.unreadMessageCount,
      view = _useInbox.view;

  var messageListRef = (0, _react.useRef)(null);

  var handleSetCurrentTab = function handleSetCurrentTab(newTab) {
    if (!(messageListRef !== null && messageListRef !== void 0 && messageListRef.current)) {
      return;
    }

    messageListRef.current.scrollTop = 0;
    setCurrentTab(newTab);
  };

  (0, _useAtBottom.useAtBottom)(messageListRef, function () {
    if (isLoading || !startCursor) {
      return;
    }

    fetchMessages({
      params: currentTab === null || currentTab === void 0 ? void 0 : currentTab.filters,
      after: startCursor
    });
  }, [isLoading, startCursor, currentTab]);
  (0, _react.useEffect)(function () {
    fetchRecipientPreferences();
  }, []);

  var handleCloseInbox = function handleCloseInbox(event) {
    event.preventDefault();
    toggleInbox(false);
  };

  var Container = renderContainer ? renderContainer : _styled.MessageListContainer;
  return /*#__PURE__*/_react["default"].createElement(_styled.ResponsiveContainer, {
    ref: ref,
    isMobile: isMobile
  }, isMobile && /*#__PURE__*/_react["default"].createElement(_styled.DismissInbox, {
    onClick: handleCloseInbox
  }, "X"), /*#__PURE__*/_react["default"].createElement(Container, null, renderHeader ? renderHeader({
    currentTab: currentTab,
    labels: labels,
    markAllAsRead: markAllAsRead,
    messages: messages,
    title: title,
    unreadMessageCount: unreadMessageCount
  }) : /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    currentTab: currentTab,
    labels: labels,
    markAllAsRead: markAllAsRead,
    messages: messages,
    title: title,
    unreadMessageCount: unreadMessageCount
  }), view === "messages" ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderTabs ? renderTabs({
    tabs: tabs,
    currentTab: currentTab
  }) : /*#__PURE__*/_react["default"].createElement(_TabList["default"], {
    labels: labels,
    tabs: tabs,
    setCurrentTab: handleSetCurrentTab,
    currentTab: currentTab
  }), /*#__PURE__*/_react["default"].createElement(_styled.MessageList, {
    ref: messageListRef,
    isMobile: isMobile,
    "data-testid": "messages"
  }, messages === null || messages === void 0 ? void 0 : messages.map(function (message) {
    return renderMessage ? renderMessage(message) : /*#__PURE__*/_react["default"].createElement(_Message["default"], (0, _extends2["default"])({}, message, {
      defaultIcon: defaultIcon,
      formatDate: formatDate,
      key: message.messageId,
      labels: labels,
      openLinksInNewTab: openLinksInNewTab,
      renderBlocks: renderBlocks
    }));
  }), isLoading && /*#__PURE__*/_react["default"].createElement(_loading["default"], null), !isLoading && (messages === null || messages === void 0 ? void 0 : messages.length) === 0 && (renderNoMessages ? renderNoMessages({}) : /*#__PURE__*/_react["default"].createElement(_styled.Empty, null, (_ref2 = (_labels$emptyState = labels === null || labels === void 0 ? void 0 : labels.emptyState) !== null && _labels$emptyState !== void 0 ? _labels$emptyState : brand === null || brand === void 0 ? void 0 : (_brand$inapp = brand.inapp) === null || _brand$inapp === void 0 ? void 0 : (_brand$inapp$emptySta = _brand$inapp.emptyState) === null || _brand$inapp$emptySta === void 0 ? void 0 : _brand$inapp$emptySta.text) !== null && _ref2 !== void 0 ? _ref2 : "You have no notifications at this time")), !isLoading && (messages === null || messages === void 0 ? void 0 : messages.length) > 5 && !startCursor && /*#__PURE__*/_react["default"].createElement(_PaginationEnd["default"], {
    title: "End Of The Road"
  }))) : /*#__PURE__*/_react["default"].createElement(_reactPreferences.PreferenceList, null)), renderFooter ? renderFooter({}) : !(brand !== null && brand !== void 0 && (_brand$inapp2 = brand.inapp) !== null && _brand$inapp2 !== void 0 && _brand$inapp2.disableCourierFooter) && /*#__PURE__*/_react["default"].createElement(_styled.Footer, null, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://www.courier.com"
  }, "Powered by\xA0\xA0", /*#__PURE__*/_react["default"].createElement(CourierLogo, null))));
});

var _default = Messages;
exports["default"] = _default;